import { OverlayShellConfig } from "../../../shared/overlay-shell/overlay.models";

export const TASKS_DETAILS_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: false,
  width: "auto",
  height: "auto",
};
